import type { Breadcrumb } from "@sentry/react";

/**
 * Sentry `beforeSend` hook: strips Authorization headers captured in
 * fetch/XHR breadcrumbs before an event leaves the browser.
 *
 * Inside the SDK, `event.breadcrumbs` is a plain `Breadcrumb[]` — the
 * `{ values: [...] }` shape only exists in the serialized wire format. Reading
 * `event.breadcrumbs.values` on the array returns `Array.prototype.values` (a
 * function), so the hook threw, and Sentry drops the original event whenever
 * `beforeSend` throws (PROD-BOOKINGS-ADMIN-PORTAL-A).
 *
 * Must never throw: any exception here silently loses the event being reported.
 */
export function sentryBeforeSend<T extends { breadcrumbs?: Breadcrumb[] }>(
  event: T,
): T {
  if (!Array.isArray(event.breadcrumbs)) return event;

  event.breadcrumbs.forEach((breadcrumb) => {
    if (breadcrumb.data?.["Authorization"]) {
      breadcrumb.data["Authorization"] = "[Filtered]";
    }
  });
  return event;
}
